import React, { useEffect, useState } from "react";
import { scrollToId } from "@/lib/scroll";

export function LogoMark({ size = 34 }) {
    return (
        <svg width={size} height={size} viewBox="0 0 64 64" aria-hidden="true">
            <rect width="64" height="64" rx="14" fill="#1A1715" />
            <text x="32" y="43" fontFamily="Georgia, 'Times New Roman', serif" fontSize="34" fontWeight="600" fill="#C49A45" textAnchor="middle">S</text>
            <rect x="14" y="50" width="36" height="2.5" rx="1.25" fill="#A84320" />
        </svg>
    );
}

const OFFER_ITEMS = [
    "🔥 স্পেশাল অফার: ৳১,৩০০-এর বদলে মাত্র ৳৯০০ — ৳৪০০ বাঁচান",
    "২টি পাঞ্জাবি একসাথে নিলে মাত্র ৳১,৭০০ — ৳৯০০ ছাড়",
    "৩টি পাঞ্জাবি মাত্র ৳২,৫০০ + ফ্রি ডেলিভারি — ৳১,৪০০ ছাড়",
    "যত বেশি নেবেন, তত বেশি সাশ্রয় — আজই অর্ডার করুন",
    "ক্যাশ অন ডেলিভারি — পণ্য হাতে পেয়ে টাকা দিন",
    "সারাদেশে হোম ডেলিভারি — ২-৪ দিনে পৌঁছে যাবে",
];

export default function Header() {
    const [hidden, setHidden] = useState(false);
    const [lastY, setLastY] = useState(0);

    useEffect(() => {
        const onScroll = () => {
            const y = window.scrollY;
            if (y > lastY && y > 80) setHidden(true);
            else setHidden(false);
            setLastY(y);
        };
        window.addEventListener("scroll", onScroll, { passive: true });
        return () => window.removeEventListener("scroll", onScroll);
    }, [lastY]);

    return (
        <header
            className={`fixed top-0 inset-x-0 z-50 bg-[#A84320] text-[#FBF9F5] border-b border-[#8C3417] shadow-md shadow-[#A84320]/20 transition-transform duration-300 ${hidden ? "-translate-y-full" : ""}`}
            data-testid="offer-header"
        >
            <div className="max-w-6xl mx-auto px-3 sm:px-6">
                {/* ─── Row 1: Headline + CTA ─── */}
                <div className="flex items-center justify-between gap-2 py-2">
                    <p className="text-[13px] sm:text-base font-bold truncate" data-testid="offer-headline">
                        যত বেশি নেবেন, তত বেশি সাশ্রয়
                    </p>
                    <button onClick={() => scrollToId("order-form")} data-testid="header-order-button"
                                        className="bg-[#1A1715] text-[#F4EFE6] text-[13px] sm:text-sm font-bold px-3.5 sm:px-5 py-1.5 sm:py-2 rounded-full hover:bg-[#8C3417] hover:text-[#FBF9F5] transition-colors duration-200 shrink-0">
                        অর্ডার করুন
                    </button>
                </div>
                {/* ─── Row 2: Offer marquee (price anchoring) ─── */}
                <div className="overflow-hidden marquee-mask py-1.5" data-testid="offer-marquee">
                    <div className="animate-marquee flex whitespace-nowrap w-max">
                        {[...OFFER_ITEMS, ...OFFER_ITEMS].map((t, i) => (
                            <span key={i} className="flex items-center text-[11px] sm:text-xs font-semibold tracking-wide">
                                <span className="px-4">{t}</span>
                                <span className="text-[#C49A45]">✦</span>
                            </span>
                        ))}
                    </div>
                </div>
            </div>
        </header>
    );
}
